import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { parseOAuthCallback } from "@/services/google";
import { useUserStore } from "@/store";
import styles from "./OAuthCallback.module.css";

export function OAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { signInWithGoogle, isAuthenticated, authError } = useUserStore();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const { code } = parseOAuthCallback(searchParams.toString());

    if (!code) {
      navigate("/onboarding", { replace: true });
      return;
    }

    signInWithGoogle(code).then((user) => {
      const store = useUserStore.getState();

      if (store.isAuthenticated) {
        console.log("hello?", user)
        if (user?.completed_onboarding_at) {
          navigate("/closet", { replace: true });
        } else {
          navigate("/syncing", { replace: true });
        }
      }
    });
  }, [searchParams, signInWithGoogle, navigate]);

  // Show error if auth failed
  if (authError) {
    return (
      <div className={styles.overlay}>
        <div className={styles.inner}>
          <div className={styles.logo}>Closai</div>
          <p className={styles.error}>{authError}</p>
          <button className={styles.retryBtn} onClick={() => navigate("/onboarding", { replace: true })}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.inner}>
        <div className={styles.logo}>Closai</div>
        <div className={styles.spinner} />
        <p className={styles.text}>{isAuthenticated ? "Connecting your email..." : "Signing you in..."}</p>
      </div>
    </div>
  );
}
